import {
  MdHome,
  MdEvent,
  MdMedicalServices,
  MdNewReleases,
} from "react-icons/md";

import Dashboard from "./views/admin/default";
import Events from "views/admin/events";
import Doctors from "views/admin/doctors";
import ServicesPage from "views/admin/offres";
import ActualitiesPage from "views/admin/actuality";

const routes = [
  {
    name: "Dashboard",
    layout: "/admin",
    path: "default",
    icon: <MdHome className="h-6 w-6" />,
    requiredRole: "admin || user ",
    component: <Dashboard />,
  },
  {
    name: "Gestion des évenements",
    layout: "/admin",
    path: "evenements",
    icon: <MdEvent className="h-6 w-6" />,
    requiredRole: "admin || user ",
    component: <Events />,
  },

  {
    name: "Gestion des médecins",
    layout: "/admin",
    path: "medecins",
    icon: <MdMedicalServices className="h-6 w-6" />,
    requiredRole: "admin || user ",
    component: <Doctors />,
  },
  {
    name: "Gestion des services",
    layout: "/admin",
    path: "services",
    icon: <MdMedicalServices className="h-6 w-6" />,
    requiredRole: "admin || user ",
    component: <ServicesPage />,
  },
  {
    name: "Gestion des actualités",
    layout: "/admin",
    path: "actualites",
    icon: <MdNewReleases className="h-6 w-6" />,
    requiredRole: "admin || user ",
    component: <ActualitiesPage />,
  },
];

export default routes;
